import { createContext, useContext, useState, useCallback } from "react";
import translations from "@/i18n/translations";

const I18nContext = createContext();

export const useI18n = () => useContext(I18nContext);

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => localStorage.getItem("cf_locale") || "en");

  const t = useCallback(
    (key, fallback) => translations[locale]?.[key] || translations.en?.[key] || fallback || key,
    [locale]
  );

  const changeLocale = useCallback((newLocale) => {
    if (translations[newLocale]) {
      setLocale(newLocale);
      localStorage.setItem("cf_locale", newLocale);
    }
  }, []);

  return (
    <I18nContext.Provider value={{ locale, t, changeLocale, locales: Object.keys(translations) }}>
      {children}
    </I18nContext.Provider>
  );
};
